// グラフ・比較.
import * as React from 'react';
import { Graph, Binding, getLocomoAxis2Max } from '../../utils/Graph';
import { MonthlyCountData } from '../../utils/MonthlyCountData';
import { JS_VOID, memoryReleaseForCanvas } from '../../utils/commonUtil';
import { MDate } from '../../utils/dateUtil';
import * as PropTypes from 'prop-types';
import * as TrainingConst from '../../constants/Training';

// ローディング中のダミー・グラフ系 props.
interface DummyDailyHistoryProps extends React.Props<{}> {
  // start, end
  className: string;

  // 親からの引き渡し用.
  mDate: MDate;

  isStartTerm: boolean;

  type: TrainingConst.TYPE;
}

// ローディング中のダミー・グラフ系.
export class DummyTrainingGraphsCompare extends React.Component<DummyDailyHistoryProps, {}> {
  private yearSelected: string;
  private monthSelected: string;
  private menuNames: string[];

  // Canvas配列(ADLの欠番のcanvasも含んでいる)
  private refCharts: (HTMLCanvasElement | null)[] = [];

  componentWillMount() {
    const mDate: MDate = this.props.mDate;
    this.yearSelected = mDate.year;
    this.monthSelected = mDate.month;

    if (this.props.type === TrainingConst.TYPE.Locomo) {
      this.menuNames = TrainingConst.SECTION_LOCOMO_NAMES;
    } else if (this.props.type === TrainingConst.TYPE.ADL) {
      this.menuNames = TrainingConst.SECTION_ADL_NAMES;
    }
  }

  componentDidMount() {
    const monthlyCountData = new MonthlyCountData(this.props.type);

    // カウント数用のテーブル
    const historyMonthly = monthlyCountData.historyTable;

    // 角度用のテーブル
    const historyMonthlyAngle = monthlyCountData.historyTableAngle;

    // tpl_locomo.jsのことをしている.
    // myChart1 腕上げ下ろし.
    const graph = new Graph();
    let width: number = 460;
    let height: number = 330;
    // 回数.
    let yAxis1Max: number = 30;
    // 角度.
    let yAxis2Max: number = 180;

    const binding: Binding = {
      value: {
        history_monthly: historyMonthly,
        history_monthly_angle: historyMonthlyAngle,
      }
    } as Binding;

    // Canvas数.
    let canvasCount = 0;
    if (this.props.type === TrainingConst.TYPE.Locomo) {
      canvasCount = 9;
    } else if (this.props.type === TrainingConst.TYPE.ADL) {
      // ADLは欠番2つも含めた数(this.refCharts.lengthはJSが添字によって変化するので使わないこと).
      canvasCount = 7;
    }

    // startなら'myChart11', endなら'myChart1'のidでグラフ生成する.
    for (let i = 0; i < canvasCount; i++) {
      let menuNumber: number = i;
      // 左側のは100番のindexにしておく.
      const myIndex: number = this.props.isStartTerm ? 100 + i : i;
      const canvasElement: HTMLCanvasElement|null = this.refCharts[myIndex];
      if (canvasElement === null) {
        continue;
      }

      if (this.props.type === TrainingConst.TYPE.Locomo) {
        // グラフのY軸角度の最大数を取得.
        yAxis2Max = getLocomoAxis2Max(menuNumber);
      } else if (this.props.type === TrainingConst.TYPE.ADL) {
        // ADLは欠番になってるのでここは飛ばす.
        // x 105: 更衣着脱衣(上半身).
        // x 106: 更衣着脱衣(靴下).
        if (TrainingConst.SKIP_ADL_IDX.indexOf(i) >= 0) {
          continue;
        }
      }

      // グラフのデータを流す.
      graph.insertDataCanvasGraph(canvasElement, binding, menuNumber, width, height, yAxis1Max, yAxis2Max);
    }
  }

  componentWillUnmount() {
    // 縦横サイズを0にしてcanvasを開放する.
    memoryReleaseForCanvas(this.refCharts);
  }

  render() {
    return (
      <div className={this.props.className}>
        <div className="calendarHeader">
          <div className="dateArea">
            <div className="date">{this.yearSelected}
              <span className="year">年</span>{this.monthSelected}
              <span>月</span>
            </div>
            <div className="btn left">
              <a />
            </div>
            <div className="btn right">
              <a />
            </div>
          </div>
          {(this.props.isStartTerm) ?
          <div className="btnStyle05 mini">
            <a>終了</a>
          </div> : (null)
          }
        </div>
        { this.menuNames.map((sectionName: string, index: number) => {
          const key = `section${index}`;
          // 左側のは100番のindexにしておく.
          const myIndex = this.props.isStartTerm ? 100 + index : index;
          return <section key={key}>
              <h3>{sectionName}</h3>
              <canvas
                ref={(item) => { this.refCharts[myIndex] = item; }}
                width="460"
                height="330"
              />
            </section>;
          })
        }
      </div>
    );
  }
}

// グラフ系props.
interface TrainingGraphsCompareProps extends React.Props<{}> {
  userId: string;

  // start, end
  className: string;

  // response内容.
  history: any;

  // 親からの引き渡し用.
  mDate: MDate;

  // 左（古い）、右（新しい）
  isStartTerm: boolean;

  type: TrainingConst.TYPE;
}

/**
 * Canvasの棒グラフ（比較画面）.
 *
 * @export
 * @class TrainingGraphsCompare
 * @extends {React.Component<TrainingGraphsCompareProps, {}>}
 */
export default class TrainingGraphsCompare extends React.Component<TrainingGraphsCompareProps, {}> {
  private userId: string;
  private yearSelected: string;
  private monthSelected: string;
  private mDate: MDate;
  private menuNames: string[];

  // Canvas配列(ADLの欠番のcanvasも含んでいる)
  private refCharts: (HTMLCanvasElement | null)[] = [];

  static get contextTypes() {
    // 親のLocomoCompareコンポーネントと橋渡しするcontext.
    return {
      // 左右.
      callbackParent: PropTypes.func,
      // ステート変更.
      changeState: PropTypes.func,
    };
  }

  componentWillMount() {
    this.userId = this.props.userId;
    this.mDate = this.props.mDate;
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;

    if (this.props.type === TrainingConst.TYPE.Locomo) {
      this.menuNames = TrainingConst.SECTION_LOCOMO_NAMES;
    } else if (this.props.type === TrainingConst.TYPE.ADL) {
      this.menuNames = TrainingConst.SECTION_ADL_NAMES;
    }
  }

  componentDidMount() {
    const monthlyCountData = new MonthlyCountData(this.props.type);

    // 7行32列の配列にresponseデータを格納
    monthlyCountData.insertData(this.props.history);

    // tpl_locomo.jsのことをしている.
    // myChart1 腕上げ下ろし.
    const graph = new Graph();
    let width: number = 460;
    let height: number = 330;
    // 回数.
    let yAxis1Max: number = 30;
    // 角度.
    let yAxis2Max: number = 180;

    // カウント数用のテーブル
    const historyMonthly = monthlyCountData.historyTable;

    // 角度用のテーブル
    const historyMonthlyAngle = monthlyCountData.historyTableAngle;
    let binding: Binding = {
      value: {
        history_monthly: historyMonthly,
        history_monthly_angle: historyMonthlyAngle,
      }
    } as Binding;

    // Canvas数.
    let canvasCount = 0;
    if (this.props.type === TrainingConst.TYPE.Locomo) {
      canvasCount = TrainingConst.MAX_LOCOMO_CNT;
    } else if (this.props.type === TrainingConst.TYPE.ADL) {
      // ADLは欠番2つも含めた数(this.refCharts.lengthはJSが添字によって変化するので使わないこと).
      canvasCount = TrainingConst.MAX_ADL_CNT;
    }

    // startなら'myChart11', endなら'myChart1'のidでグラフ生成する.
    for (let i = 0; i < canvasCount; i++) {
      let menuNumber: number = i;
      // 左側のは100番のindexにしておく.
      let myIndex: number = this.props.isStartTerm ? 100 + i : i;
      const canvasElement: HTMLCanvasElement|null = this.refCharts[myIndex];
      if (canvasElement === null) {
        continue;
      }

      if (this.props.type === TrainingConst.TYPE.Locomo) {
        // グラフのY軸角度の最大数を取得.
        yAxis2Max = getLocomoAxis2Max(i);
      } else if (this.props.type === TrainingConst.TYPE.ADL) {
        // ADLはお風呂系よりあとはY軸100.
        if (i >= 2) {
          yAxis2Max = 100;
        }

        // ADLは欠番になってるのでここは飛ばす.
        // x 105: 更衣着脱衣(上半身).
        // x 106: 更衣着脱衣(靴下).
        if (TrainingConst.SKIP_ADL_IDX.indexOf(i) >= 0) {
          continue;
        }
      }

      // グラフにデータを流す.
      graph.insertDataCanvasGraph(canvasElement, binding, menuNumber, width, height, yAxis1Max, yAxis2Max);
    }
  }

  componentWillUnmount() {
    // 縦横サイズを0にしてcanvasを開放する.
    memoryReleaseForCanvas(this.refCharts);
  }

  // 左をクリックしたときの処理.
  minusMonthly = (yearSelected: string, monthSelected: string) => {
    // 先月.
    this.mDate.setPreMonth();

    // 親contextのメソッド.
    this.context.callbackParent(this.props.isStartTerm, this.mDate.yearmonth);
  }

  // 右をクリックしたときの処理.
  plusMonthly = (yearSelected: string, monthSelected: string) => {
    // 次の月.
    this.mDate.setNextMonth();

    // 親contextのメソッド.
    this.context.callbackParent(this.props.isStartTerm, this.mDate.yearmonth);
  }

  // 終了をクリックしたときの処理.
  toFinishCompare = (userId: string) => {
    this.context.changeState(TrainingConst.DETAIL_STATE);
  }

  render() {
    return (
      <div className={this.props.className}>
        <div className="calendarHeader">
          <div className="dateArea">
            <div className="date">{this.yearSelected}
              <span className="year">年</span>{this.monthSelected}
              <span>月</span>
            </div>
            <div className="btn left">
              <a
                href={JS_VOID} 
                onClick={event => this.minusMonthly(this.yearSelected, this.monthSelected)}
              />
            </div>
            <div className="btn right">
              <a
                href={JS_VOID} 
                onClick={event => this.plusMonthly(this.yearSelected, this.monthSelected)}
              />
            </div>
          </div>
          {(this.props.isStartTerm) ?
            <div className="btnStyle05 mini">
              <a onClick={event => this.toFinishCompare(this.userId)}>終了</a>
            </div> : false
          }
        </div>
        { this.menuNames.map((sectionName: string, index: number) => {
          const key = `section${index}`;
          // 左側のは100番のindexにしておく.
          const myIndex: number = this.props.isStartTerm ? 100 + index : index;

          // ADLは欠番になってるのでここは飛ばす.
          if (this.props.type === TrainingConst.TYPE.ADL) {
            // x 105: 更衣着脱衣(上半身).
            // x 106: 更衣着脱衣(靴下).
            if (TrainingConst.SKIP_ADL_IDX.indexOf(index) >= 0) {
              return (null);
            }
          } 

          return <section key={key}>
              <h3>{sectionName}</h3>
              <canvas
                ref={(item) => { this.refCharts[myIndex] = item; }}
                width="460"
                height="330"
              />
            </section>;
          })
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/TrainingGraphsCompare.tsx